import { Inject, NgZone } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogData } from "src/app/header/header.component";

@Component({
	selector: 'app-element-info-popup',
	templateUrl: './element-info-popup.component.html'
})

export class ElementInfoPopupComponent implements OnInit {
    content;
    constructor(
        private ngZone: NgZone,
		public dialogRef: MatDialogRef<ElementInfoPopupComponent>,
		@Inject(MAT_DIALOG_DATA) public data: DialogData
	) { }

    ngOnInit() {
		this.content = this.data;
	}

	onNoClick(): void {
        this.ngZone.run(() => {
          this.dialogRef.close();
        });
    }
}